import React from "react";

const Chips = (props) => {
  const {
    data,
    firstChild,
    lastChild,
    selectedFilterOption,
    setSelectedFilterOption,
    selectedTab,
  } = props;

  const handleClick = (option, i) => {
    setSelectedFilterOption(option.id);
  };

  return (
    <div
      onClick={() => handleClick(data)}
      className={`rounded-[16px] px-[10px] py-[7px] mx-[8px] text-[12px] ${
        firstChild ? "ml-[16px]" : ""
      } ${lastChild ? "mr-[16px]" : ""} ${
        selectedFilterOption === data.id
          ? "bg-[#1C75BC] text-[#FFFFFF]"
          : "border border-[#E0E0E0]"
      }`}
    >
      {`${data.text} ${
        selectedTab.id !== "QcDone"
          ? `(${data.processInstanceData?.total || 0})`
          : ""
      }`}
    </div>
  );
};

export default Chips;
